export default "__VITE_ASSET__DjNIwsC6__"